export class PwaStore {
    isInstalled = false; // Indicate if the user has installed PWA
    a2hsLastPrompt: Date; // The last date when the "Add To Home Screen" button was display to user (prompt to install PWA).
    a2hsRetry = 0; // Number of retry to display "Add To Home Screen" button (3 times maximum).
    promptExternalAppStoreIds = new Array<string>(); // id app's list of mobile application, available in store, which prompt to install from PWA (DeepLink not works from PWA!)
}
